module.exports = __webpack_public_path__ + "static/img/ntby3.ad4016e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ntby3.png
// module id = I+E1
// module chunks = 0